import React from "react";
import {SelectOperater} from "./SelectOperater";
import {PhoneNumberInput} from "./PhoneNumberInput";
import {SelectAmount} from "./SelectAmount";
import {AppController} from "../controller/AppController";
import {useState} from "../state/useState";
import {phoneNumberSelected, selectAmount, selectOperatorByName, redirectTo} from "../state/action";
import {order} from "../service/RechargeService";
import {MobileData} from "./MobileData";
import {VoucherData} from "./VoucherData";


export function ChooseService({history}) {

    let [state, dispatch] = useState();

    function onSubmit(value) {
        value.preventDefault();
        history.push("/confirm");
    }

    function render() {
        let operator = state.selectedOperator;
        switch (operator && operator.index) {
            case 3:
            case 1:
            case 2:
            case 4:
            case 6:
                return <MobileData/>;
            case 8:
            case 13:
                return <VoucherData deliveryTypes={state.deliveryTypes} selectedDeliveryType={state.deliveryType}/>
            default:
                return null;
        }
    }

    return <>
        <div className="page_title2">
            <div className="container">

                <div className="title"><h1>Kviklik</h1></div>
            </div>
        </div>

        <div className="clearfix"></div>


        <div className="features_sec12">


        </div>


        <div className="clearfix"></div>


        <div className="container">

            <div className="one_half"><img src={require("../assets/images/kviklik.png")} alt="" className="img_size1"/>
            </div>

            <div className="one_half last">

                <form className="sky-form" onSubmit={onSubmit}>
                    <h2 className="ipages_title1"><strong>KVIKLIK </strong>- DOPUNI KLIKOM!</h2>

                    <fieldset>
                        <SelectOperater operaters={state.operators}
                                        selectedOperator={state.selectedOperator}
                                        onChange={(name) => dispatch(selectOperatorByName(name))}/>
                        {render()}
                    </fieldset>
                    <footer>
                        <button className={"button button-login"}>Dopuni</button>
                    </footer>
                </form>

            </div>

            <div className="container">

            </div>


        </div>


        <div className="divider_line_half">
            <div className="container"></div>
        </div>

        <div className="content_fullwidth">
            <div className="container">


                <div className="one_half">

                    <h3 className="nocaps">Dopune mobilnih operatera kupujete na sljedeći način: </h3>
                    <blockquote><p>
                        <i className="fa fa-chevron-circle-right"></i> Izaberite mobilnog operatera</p>
                        <p><i className="fa fa-chevron-circle-right"></i> Unesite željeni broj mobitela na koji želite
                            dopunu</p>
                        <p><i className="fa fa-chevron-circle-right"></i> Izaberite iznos dopune i kliknite na „Dopuni“
                        </p>
                    </blockquote>
                    <p>
                        Na sljedećoj stranici birate način plaćanja e-pay (bankarskom karticom) ili sredstvima sa vašeg
                        xPay računa, a zatim popunite potrebne podatke i završite plaćanje.
                    </p>
                    <p>&nbsp;</p>

                </div>





                <div className="clearfix"></div>

                <div className="features_sec16"></div>

            </div>

        </div>

        <div className="clearfix"></div>

    </>

}
